/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type UpdateBeneficiariesRequestItemStatus = typeof UpdateBeneficiariesRequestItemStatus[keyof typeof UpdateBeneficiariesRequestItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBeneficiariesRequestItemStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  INACTIVE: 'INACTIVE',
  NEW: 'NEW',
  REMOVED: 'REMOVED',
} as const;
